export default {
  sm: 740,
}
